import { render, staticRenderFns } from "./phoneList.vue?vue&type=template&id=1557010a&scoped=true"
import script from "./phoneList.vue?vue&type=script&lang=js"
export * from "./phoneList.vue?vue&type=script&lang=js"
import style0 from "./phoneList.vue?vue&type=style&index=0&id=1557010a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1557010a",
  null
  
)

export default component.exports